import Repository from "./Repository";
// For general
const resource1 = "/api/v1/athlete/";
// For additional
const resource2 = "/api/v1/additional/";

export default {
  getAthleteInfo(id) {
    let subUrl = `${resource1}getone/${id}`;
    return Repository.sendReq({ method: "get", subUrl });
  },

  // Post player data
  registerPlayer(data) {
    let subUrl = resource1;
    return Repository.sendReq({ method: "post", subUrl, data });
  },

  // Delete player data
  deleteProfile(id) {
    let subUrl = `${resource1}${id}`;
    return Repository.sendReq({ method: "delete", subUrl });
  },

  // Submit Payment data
  // addPaymentType(values, id) {
  //   let url = `${resource1}${id}`;
  //   return Repository.sendReq("put", url, values);
  // },

  // Edit player data
  editPlayerData(data, id) {
    let subUrl = `${resource1}${id}`;
    return Repository.sendReq({ method: "put", subUrl, data });
  },

  // Post additional data
  postPlayerImages(data, id) {
    let subUrl = `${resource1}image/${id}`;
    return Repository.sendReq({ method: "post", subUrl, data });
  },
  postPlayerTeams(data) {
    let subUrl = `${resource2}teamPlayed`;
    return Repository.sendReq({ method: "post", subUrl, data });
  },
  editPlayerTeams(data, id) {
    let subUrl = `${resource2}teamPlayed/${id}`;
    return Repository.sendReq({ method: "put", subUrl, data });
  },
  deletePlayerTeams(id, data) {
    let subUrl = `${resource2}teamPlayed/${id}`;
    return Repository.sendReq({ method: "delete", subUrl, data });
  },
  postPlayerVideos(data) {
    let subUrl = `${resource2}video`;
    return Repository.sendReq({ method: "post", subUrl, data });
  },
  //Videos
  getPlayerVideos(data, id) {
    let subUrl = `${resource2}video/${id}`;
    return Repository.sendReq({ method: "get", subUrl, data });
  },
  editPlayerVideos(data, id) {
    let subUrl = `${resource2}video/${id}`;
    return Repository.sendReq({ method: "put", subUrl, data });
  },
  deletePlayerVideos(id, data) {
    let subUrl = `${resource2}video/${id}`;
    return Repository.sendReq({ method: "delete", subUrl, data });
  }
};
